import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Children } from 'react';
var css = {
  "dropdown": "rui-ekohH",
  "hide": "rui-oWXXL"
};
import classNames from 'classnames';
var Dropdown = /*#__PURE__*/function (_React$Component) {
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _callSuper(this, Dropdown, [props]);
    _this.handleClickOutside = function (event) {
      var domNode = _this.dropdownContainer;
      if ((!domNode || !domNode.contains(event.target)) && _this.props.opened) {
        _this.props.onClickOutside();
      }
    };
    _this.state = {
      opened: props.opened
    };
    return _this;
  }
  _inherits(Dropdown, _React$Component);
  return _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (typeof document !== 'undefined') {
        document.addEventListener('click', this.handleClickOutside, true);
        document.addEventListener('touchstart', this.handleClickOutside, true);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', this.handleClickOutside, true);
        document.removeEventListener('touchstart', this.handleClickOutside, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        actionable = _this$props.actionable,
        opened = _this$props.opened,
        alwaysInsertContent = _this$props.alwaysInsertContent,
        listStyle = _this$props.listStyle,
        listClassName = _this$props.listClassName,
        children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(css.dropdown, className),
        style: style,
        ref: function ref(element) {
          _this2.dropdownContainer = element;
        }
      }, actionable, (opened || alwaysInsertContent) && (/*#__PURE__*/React.createElement("ul", {
        style: listStyle,
        className: classNames(listClassName, _defineProperty({}, css.hide, !opened))
      }, Children.map(children, function (option, key) {
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, option);
      }))));
    }
  }]);
}(React.Component);
Dropdown.defaultProps = {
  opened: false,
  listClassName: '',
  style: {},
  listStyle: {},
  onClickOutside: function onClickOutside() {},
  alwaysInsertContent: false
};
export default Dropdown;